var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass:
        "flex flex-row gap-4 items-top customContainer pt-8 pb-5 justify-flex-start pr-6 items-flex-start",
    },
    [
      [
        _c(
          "div",
          { staticClass: "flex flex-col items-top gap-4 sm:flex-row" },
          [
            _c("FormGroupNew", {
              attrs: {
                type: "search",
                iconStyle: "customIcon",
                inputClass: "customFormInput",
                placeholder: "Search by name",
                debounceTime: 500,
                isIcon: "yes",
              },
              model: {
                value: _vm.name,
                callback: function ($$v) {
                  _vm.name = typeof $$v === "string" ? $$v.trim() : $$v
                },
                expression: "name",
              },
            }),
            _c(
              "FormGroupNew",
              { attrs: { debounceTime: 500 } },
              [
                _c("TitlesMultiselect", {
                  attrs: { getcontainerStyle: "smallHeight" },
                  model: {
                    value: _vm.titles,
                    callback: function ($$v) {
                      _vm.titles = $$v
                    },
                    expression: "titles",
                  },
                }),
              ],
              1
            ),
            _c(
              "FormGroupNew",
              { attrs: { debounceTime: 500 } },
              [
                _c("ProfileCountrySelect", {
                  attrs: { multiple: "", getcontainerStyle: "smallHeight" },
                  model: {
                    value: _vm.countries,
                    callback: function ($$v) {
                      _vm.countries = $$v
                    },
                    expression: "countries",
                  },
                }),
              ],
              1
            ),
            _c("RegionInput", {
              attrs: {
                countries: _vm.countries,
                multiple: "",
                iconStyle: "customIcon",
                inputClass: "customFormInput",
                getcontainerStyle: "smallHeight",
                isIcon: "yes",
                debounceTime: 500,
              },
              model: {
                value: _vm.states,
                callback: function ($$v) {
                  _vm.states = $$v
                },
                expression: "states",
              },
            }),
            _c(
              "FormGroupNew",
              { attrs: { debounceTime: 500 } },
              [
                _c("UserCitiesMultiNew", {
                  attrs: {
                    getcontainerStyle: "smallHeight",
                    country: _vm.countriesNames,
                    state: _vm.statesNames,
                  },
                  model: {
                    value: _vm.cities,
                    callback: function ($$v) {
                      _vm.cities = $$v
                    },
                    expression: "cities",
                  },
                }),
              ],
              1
            ),
            _vm.getRoleAdmin
              ? _c(
                  "FormGroupNew",
                  { attrs: { debounceTime: 500 } },
                  [
                    _c("ProjectsMultiselect", {
                      attrs: {
                        placeholder: "Search by Client",
                        getcontainerStyle: "smallHeight",
                      },
                      model: {
                        value: _vm.projectsIds,
                        callback: function ($$v) {
                          _vm.projectsIds = $$v
                        },
                        expression: "projectsIds",
                      },
                    }),
                  ],
                  1
                )
              : _vm._e(),
          ],
          1
        ),
        _c("UiButtonMessage", {
          attrs: {
            buttonClass: "customAdd",
            buttonText: "Reset",
            textClass: "customText customOnlyText",
          },
          on: { click: _vm.handleReset },
        }),
      ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }